function mixedDimension() {
  const mixedDimension = {order: 'natural'};
  mixedDimension.field = this.measures().map(d => d.field).join('-');
  return mixedDimension;
}

export default mixedDimension;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/mixedDimension.js